class CartUpsell extends HTMLElement {
  constructor() {
    super();

    this.productsWrap = this.querySelector('[data-cart-upsell-products]');
    this.CartproductsWrap = this.querySelector('[data-main-cart-upsell-products]');
    this.carouselElement = this.querySelector('.swiper');
    this.swiper = null;
    this.init();
  }

  init() {
    this.checkCount()
  }

  checkCount() {
    if (this.productsWrap) {
      const { left, recommendationUrl } = this.productsWrap.dataset;
      if (parseFloat(left) > 0 && typeof recommendationUrl != 'undefined') {
        this.buildRecommendations(recommendationUrl);
      } else {
        this.initCarousel();
      }
    }
    if (this.CartproductsWrap) {
      const { left, recommendationUrl } = this.CartproductsWrap.dataset;
      if (parseFloat(left) > 0 && typeof recommendationUrl != 'undefined') {
        this.buildCartRecommendations(recommendationUrl);
      } else {
        this.initCartCarousel();
      }
    }
  }

  buildCartRecommendations(recommendationUrl) {
    fetch(recommendationUrl)
    .then(response => response.text())
    .then(text => {
      const emptyDiv = document.createElement('div');
      emptyDiv.innerHTML = text;
      const recommendations = emptyDiv.querySelector('.cart-recommendations-section');
      const currentHtml = this.CartproductsWrap.innerHTML
      this.CartproductsWrap.innerHTML = `
        ${currentHtml}
        ${recommendations.innerHTML}
      `
      this.initCartCarousel()
    })
    .catch(e => {
      this.initCartCarousel()
      console.error(e);
    });
  }
  buildRecommendations(recommendationUrl) {
    fetch(recommendationUrl)
    .then(response => response.text())
    .then(text => {
      const emptyDiv = document.createElement('div');
      emptyDiv.innerHTML = text;
      const recommendations = emptyDiv.querySelector('.cart-recommendations-section');
      const currentHtml = this.productsWrap.innerHTML
      this.productsWrap.innerHTML = `
        ${currentHtml}
        ${recommendations.innerHTML}
      `
      this.initCarousel()
    })
    .catch(e => {
      this.initCarousel()
      console.error(e);
    });
  }

  initCartCarousel() {
    var that=this;
    this.swiper = new Swiper(this.carouselElement, {
      loop: true,
      centerInsufficientSlides: true,
      slidesPerView: 1.5,
      spaceBetween: 24,
      breakpoints: {
        480: {
         slidesPerView: 2
        },
        768: {
         slidesPerView: 3
        },
        1024: {
         slidesPerView: 4
        }
      },
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
        renderBullet: function (index, className) {
          var d_label=that.carouselElement.querySelector('.swiper-slide:nth-child('+(index+1)+')').getAttribute('data-slide-label');
          return '<span class="' + className + '" aria-label="Slide ' + (index + 1) + ' - '+d_label+'"></span>';
        }
      },
      // Navigation arrows
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
    });
  }
  initCarousel() {
    this.swiper = new Swiper(this.carouselElement, {
      loop: true,
      centerInsufficientSlides: true,
      slidesPerView: 1.5,
      spaceBetween: 24,
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '" aria-label="Slide ' + (index + 1) + '"></span>';
        }
      },
      // Navigation arrows
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
    });
  }
}

if (!customElements.get('component-cart-upsell')) {
  customElements.define('component-cart-upsell', CartUpsell);
}
